import React from 'react'
import { IconMaps } from '@ow/icons'

export const fieldTypes = [
  {
    type: 'text',
    title: '文本',
    icon: (color) => (
      <IconMaps type="textIcon" fill={color} width={14} height={14} />
    ),
  },
  // {
  //   type: '',
  //   title: '多行文本',
  //   icon: (color) => (
  //     <IconMaps type="multiText" fill={color} width={14} height={14} />
  //   ),
  // },
  {
    type: 'dropSelect',
    title: '选择',
    multiple: false,
    icon: (color) => (
      <IconMaps type="selectIcon" fill={color} width={14} height={14} />
    ),
  },
  // {
  //   type: 'dropSelect',
  //   title: '多选',
  //   multiple: true,
  //   icon: (color) => (
  //     <IconMaps type="multiSelect" fill={color} width={14} height={14} />
  //   ),
  // },
  {
    type: 'number',
    title: '数值',
    icon: (color) => (
      <IconMaps type="numberIcon" fill={color} width={14} height={14} />
    ),
  },
  {
    type: 'area',
    title: '点位',
    icon: (color) => (
      <IconMaps type="areaIcon" fill={color} width={14} height={14} />
    ),
  },
  {
    type: 'standard',
    title: '指标',
    icon: (color) => (
      <IconMaps type="standardIcon" fill={color} width={14} height={14} />
    ),
  },
  {
    type: 'geolocation',
    title: '定位',
    icon: (color) => (
      <IconMaps type="geolocationIcon" fill={color} width={14} height={14} />
    ),
  },
  {
    type: 'media',
    title: '上传',
    icon: (color) => (
      <IconMaps type="linkIcon" fill={color} width={14} height={14} />
    ),
  },
]
